import {api as backend} from '../backend'
import {createLocal} from './local_record_actions'
import {handleRes} from './handle_res'
import {getParams} from './helpers'
import {backendKind} from '../record_building/record_keys'
import {index} from './index_request'

export async function show(kind, id, {extraParams = {}, localKind} = {}) {
	const res = await backend.get(`${kind}/${id}`, extraParams)
	if (res.ok && res.data && res.data.item) {
		const {item} = res.data
		const createKind = localKind || kind
		createLocal(createKind, item)
		return {ok: true, item}
	}
}

export async function resourceReq(kind, url, config = {}) {
	const {params, method: requestedMethod} = makeArbDefault(config, {defaultMethod: 'put'})

	const backendKey = backendKind(kind)
	const isCreate = !params['id']
	const defaultMethod = isCreate ? 'post' : 'put'
	let method = requestedMethod
	if (!method) method = defaultMethod
	method = method.toLowerCase()
	const fullUrl = isCreate ? `${backendKey}/${url}` : `${backendKey}/${params['id']}/${url}`
	const resourceParams = getParams(kind, params)

	const res = await backend[method](fullUrl, resourceParams)
	return handleRes(res, kind, params)
}

const makeArbDefault = (config, {defaultMethod = 'post'} = {}) => {
	let method = defaultMethod
	let params = config

	if (config.extraParams) params = {}

	if (config.params || config.method) {
		// this means the argument is a settings object instead of just params
		params = config.params
		method = config.method || method
	}

	return {method, params}
}

export async function getByIds(kind, ids) {
	const normalizedIds = ids
		.map(Number)
		.uniq()
		.sort((a, b) => a - b)
	if (!normalizedIds.length) return
	return index(kind, {
		filters: {ids: normalizedIds},
	})
}

// TODO added
const getAssocDiff = (newIds = [], oldIds = []) => {
	const removed = oldIds.filter(id => !newIds.includes(id))
	const added = newIds.filter(id => !oldIds.includes(id))
	return {added, removed}
}

export async function multiDestroy(kind, ids, {extraParams = {}} = {}) {
	const res = await backend.post(`${kind}/multi_destroy`, {
		ids,
		...extraParams,
	})
	return handleRes(res, kind)
}

export async function destroyMutation(kind, id) {
	kind = backendKind(kind)
	const res = await backend.delete(`${kind}/${id}/mutation`)
	return handleRes(res, kind)
}

const makeAssocParams = (newAssocs, oldAssocs) => {
	const obj = {}
	const updateKeys = Object.keys(newAssocs)
	updateKeys.forEach(key => {
		obj[key] = getAssocDiff(newAssocs[key], oldAssocs[key])
	})
	return obj
}

export async function addRemoveAssoc(kind, newAssocs, oldAssocs, id) {
	const params = makeAssocParams(newAssocs, oldAssocs)
	const obj = getParams(kind, params)
	const res = await backend.put(`${kind}/${id}/add_remove_assoc`, obj)
	return handleRes(res, kind, params)
}

// TODO added since we are using it quite often, check if this is desired
export async function toggle(kind, params) {
	const obj = getParams(kind, params)
	const url = `${kind}/${params.id}/toggle`
	const res = await backend.post(url, obj)
	if (res.ok) {
		const {item} = res.data
		createLocal(kind, item)
	}
}

// TODO added since we are using it quite often, check if this is desired
export async function arbitrary(kind, url, config = {}) {
	const {params, method} = makeArbDefault(config)
	const extraParams = config.extraParams || {}
	kind = backendKind(kind)

	const _url = !kind || url.match(/\//) ? url : `${kind}/${url}`
	let finalParams = kind ? getParams(kind, params) : params
	finalParams = {...finalParams, ...extraParams}

	// TODO sending a body with a get request is not allowed, results in an error in iOS
	let res
	if (method === 'get') {
		res = await backend.get(_url)
	} else {
		res = await backend.any({method, url: _url, data: finalParams})
	}
	return handleRes(res, kind, params)
}
